import { render, staticRenderFns } from "./PuzzleSearchTextBox.vue?vue&type=template&id=46d87858&scoped=true&"
import script from "./PuzzleSearchTextBox.vue?vue&type=script&lang=ts&"
export * from "./PuzzleSearchTextBox.vue?vue&type=script&lang=ts&"
import style0 from "./PuzzleSearchTextBox.vue?vue&type=style&index=0&id=46d87858&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d87858",
  null
  
)

export default component.exports